import AppWrapper from '../../config/appWrapper'
import { PlayerConsumerProps, PlayerConsumer } from 'modules/player/components/player'

const LivePlayerConsumer = (props: PlayerConsumerProps) => (
  <AppWrapper>
    <PlayerConsumer {...props} />
  </AppWrapper>
)

export default LivePlayerConsumer
